import {Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, {useState} from "react";
import Button from "@mui/material/Button";

export function ConfirmationDialog(props: {
    isOpen: boolean,
    onClose: () => void,
    onAccept: () => Promise<void>,
    headerText: string,
    content: React.ReactNode,
    confirmButtonText?: string,
    cancelButtonText?: string,
}) {
    const [isLoading, setIsLoading] = useState(false);

    const confirmButtonText = props.confirmButtonText || "Bestätigen";
    const cancelButtonText = props.cancelButtonText || "Abbrechen";

    function handleClose(event: React.MouseEvent<HTMLButtonElement>) {
        if (isLoading) return;
        event.preventDefault();
        props.onClose();
    }

    function handleAccept(event: React.MouseEvent<HTMLButtonElement>) {
        if (isLoading) return;
        setIsLoading(true);
        event.preventDefault();
        props.onAccept().finally(() => {
            setIsLoading(false);
        });
    }

    return (
        <Dialog open={props.isOpen} onClose={handleClose}>
            <DialogTitle>
                {props.headerText}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{position: 'absolute', right: 8, top: 8}}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {props.content}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 2,
                    }}
                >
                    {!isLoading && <Button
                        disabled={isLoading}
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                    >
                        {cancelButtonText}
                    </Button>}
                    <Button
                        fullWidth={isLoading}
                        disabled={isLoading}
                        variant="contained"
                        color="success"
                        onClick={handleAccept}
                    >
                        {isLoading ? <CircularProgress size={24}/> : confirmButtonText}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}